export default __webpack_public_path__ + "static/media/productStrategy.23749fe9.svg";